import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';
import { NotificationService } from '../../services/notification.service';

import { TranslateService } from '@ngx-translate/core';

import { CookieService } from 'ngx-cookie-service';

const { detect } = require('detect-browser');

@Component({
  selector: 'auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit, OnDestroy {
  fileToUpload = null;
  isIEOrEdge: Boolean;
  isIE: Boolean;

  browser: any;

  user: any = { email: '', password: '' };
  newUser = null;
  private _redirect = [''];
  private _routeParams = {};
  private _sub: any;

  show = [false, false];

  constructor(private _auth: AuthService, private _notification: NotificationService,
    private _router: Router, private _userService: UserService, private _route: ActivatedRoute,
    public translate: TranslateService, private cookieService: CookieService) {
  }

  private _constructRedirect() {
    if (this._routeParams['redirect']) {
      this._redirect = JSON.parse(this._routeParams['redirect']) || [''];
    }
  }

  ngOnDestroy() {
    this._sub.unsubscribe();
  }

  sanitizeQueryParams(params) {
    var p = {};
    ['status', 'room', 'owner', 'tabindex', 'pid', 'redirect'].forEach(x => {
      if (params.hasOwnProperty(x)) {
        p[x] = params[x];
      }
    });

    return p;
  }

  ngOnInit() {

    this._sub = this._route.queryParams.subscribe(params => {
      this._routeParams = params;
      this._constructRedirect();
      if (this._router.url === '/registration') {
        this.startRegister();
      }
    });
    this.browser = detect();

    this.isIE = this.browser.name == 'ie';

    let token = this.cookieService.get('token');
    if (!this._routeParams['loggedOut'] && token && !this.user['email']) {
      this._userService.whoAmI().catch().subscribe(
        user => {
          this.translate.use(user['lang']);
          document.documentElement.setAttribute("lang", user['lang']);
          this._route.queryParams.subscribe(params => {
            this._router.navigate(this._redirect, { queryParams: this.sanitizeQueryParams(params) });
          });
        },
        err => {
          this.user = { email: '', password: '' };
        }
      );
    } else {
      this.user = { email: '', password: '' };
    }
  }

  isLoggedIn() {
    return this._auth.isLoggedIn();
  }

  logIn() {
    console.log("login");
    if (!this.user.email || !this.user.password) {
      return this._notification.errorClient('AUTH.ERROR.INFORMATION_INCOMPLETE');
    }
    this._auth.logIn(this.user)
      .subscribe(
        token => {
          this._userService.whoAmI().catch()
            .subscribe(
              user => {
                this.translate.use(user['lang']);
                document.documentElement.setAttribute("lang", user['lang']);
                this._router.navigate(this._redirect, { queryParams: this._route.queryParams });
              },
              err => {
                console.error(err);
                this._notification.errorServer(err);
              }
            )
        },
        err => this._notification.errorServer('AUTH.ERROR.INCORRECT_DATA')
      );
  }

  LogOut() {
    this._auth.logOut();
    this.user = { email: '', password: '' };
  }

  passwordSecured() {
    return (this.newUser && this.newUser.password) ? this._userService.passwordSecured(this.newUser.password) : false;
  }

  newUserIsValid() {
    function emailValid(email) {
      var expr = "[A-Z0-9._+-]+@[A-Z0-9.-]+\.[A-Z]{2,}";
      var pattern = new RegExp(expr, 'i');

      return pattern.test(email);
    }

    return (this.newUser.password == this.newUser.confirm_password && this.newUser.profile.firstname && this.newUser.profile.lastname && this.newUser.email
      && emailValid(this.newUser.email) && this.newUser.profile.address.address && this.newUser.profile.address.zip && this.newUser.profile.address.city && this.newUser.profile.address.country);
  }

  startRegister() {
    this.newUser = {
      email: "",
      password: "",
      confirm_password: "",
      profile: {
        name: "",
        phone: "",
        address: {},
        logo: {},
        fromEmail: "",
        useFromEmail: false,
        fromEmailVerified: false
      },
    }
  }

  checkKey(e) {
    if (e.keyCode == 13) {
      this.logIn();
    }
  }

  forgotPassword() {
    this._router.navigate(['forgot-password']);
  }

  updateUseFromEmail(value) {
    if (value === "1" && !this.newUser.profile.fromEmail) {
      this.newUser.profile.fromEmail = this.newUser.email;
    }
  }

  register() {
    this.newUser.profile.lang = this.translate.currentLang;
    this.newUser.profile.useFromEmail = this.newUser.profile.useFromEmail == '1';

    if (!this.newUser.profile.useFromEmail) {
      this.newUser.profile.fromEmail = '';
    }
    this._userService.createUser(this.newUser).subscribe(
      (result: any) => {
        this.user.email = this.newUser.email;
        this.user.password = this.newUser.password;

        if (this.fileToUpload && result.profile.logo) {
          this._auth.logIn(this.user)
            .subscribe(
              token => {
                this._userService.uploadImg(result.url, this.fileToUpload).subscribe(

                  success => {
                    this.logIn();
                  })

              })
        } else {
          this.logIn();

        }
      },
      err => {
        this._notification.errorClient(err && err.error || 'failed');
      }
    );
  }



  fileChangeEvent(fileInput) {
    var file = fileInput.target.files[0];
    this.fileToUpload = fileInput.target.files[0];
    this.newUser.profile.logo = { type: file.type, name: file.name }
  }

  showMenu(event, idx) {
    this.show.fill(false);
    var _self = this;

    function helper() {
      _self.show[idx] = false;
      document.removeEventListener('click', helper);
    }

    this.show[idx] = true;
    document.addEventListener('click', helper);
    event.stopPropagation();
    return false;
  }
}
